import { useEffect, useState } from 'react';
import { window_open } from 'src/utils/flutter';
import { useAnalytics } from 'use-analytics';
import { Box } from 'src/ui/box';
import { Button } from 'src/ui/button';
import { Checkbox } from 'src/ui/checkbox';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from 'src/ui/dialog';
import { useMediaQuery } from 'src/ui/hooks/useMediaQuery';
import { theme } from 'src/ui/theme/theme-options';
import { Typography } from 'src/ui/typography';

interface Props {
  open: boolean;
  handleClose: () => void;
  inspections: any;
  vehicle: any;
}

const PrintModal: React.FC<Props> = ({
  open,
  handleClose,
  inspections,
  vehicle,
}) => {
  const { track } = useAnalytics();
  const smBelow = useMediaQuery(theme.breakpoints.down('sm'));

  const [printOptions, setPrintOptions] = useState([] as any);

  useEffect(() => {
    const options = [
      {
        id: null,
        key: 'details',
        title: 'Vehicle Details',
        checked: false,
      },
      {
        id: null,
        key: 'window-sticker',
        title: 'Window Sticker',
        checked: false,
      },
      {
        id: null,
        key: 'transportation',
        title: 'Transportation',
        checked: false,
      },
    ] as any;

    if (inspections && inspections.length) {
      options.push({
        id: null,
        key: 'certificate',
        title: 'Checklist Certificate',
        checked: false,
      });
    }

    inspections
      ? inspections.map((inspection: any) => {
          options.push({
            key: null,
            id: inspection.id,
            title: inspection.inspection_template.title ?? '',
            checked: false,
          });
        })
      : null;

    setPrintOptions(options);
  }, [inspections]);

  const onChecked = (index: number) => {
    const itemRef = [...printOptions];

    itemRef[index].checked = !itemRef[index].checked;

    setPrintOptions([...itemRef]);
  };

  const onSavedClick = () => {
    const pages = printOptions
      .filter((option: any) => option.key)
      .filter((option: any) => option.checked)
      .map((option: any) => option.key)
      .join(',');
    const inspectionIds = printOptions
      .filter((option: any) => option.id)
      .filter((option: any) => option.checked)
      .map((option: any) => option.id)
      .join(',');
    track(
      'print-modal-print',
      {
        pages,
        inspectionIds,
        vehicleId: vehicle.id,
        vin: vehicle.vin,
      },
      {
        component: 'sales-packet',
        custom: { vin: vehicle.vin },
      }
    );
    if (window.location.hostname === 'staging-next.carketa.app') {
      window_open(
        `https://us-central1-carketa-prod.cloudfunctions.net/production-sales-packet-pdf-v2?id=${vehicle.id}&vin=${vehicle.vin}&pages=${pages}&inspectionIds=${inspectionIds}`,
        '_blank',
        'noreferrer'
      );
    } else if (window.location.hostname === 'localhost') {
      window_open(
        `http://localhost:8080?id=${vehicle.id}&vin=${vehicle.vin}&pages=${pages}&inspectionIds=${inspectionIds}`,
        '_blank',
        'noreferrer'
      );
    } else {
      window_open(
        `https://us-central1-carketa-prod.cloudfunctions.net/production-sales-packet-pdf-1?id=${vehicle.id}&vin=${vehicle.vin}&pages=${pages}&inspectionIds=${inspectionIds}`,
        '_blank',
        'noreferrer'
      );
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent
        fullScreen={smBelow}
        closeIcon
        title="Print Options"
        className="sm:min-w-[380px]"
      >
        <DialogTitle>Print Options</DialogTitle>
        <Box className="flex min-h-[200px] min-w-[380px] flex-col items-start justify-start p-4">
          {printOptions
            ? printOptions.map((option: any, index: number) => {
                return (
                  <Box key={index} className="flex items-center justify-center">
                    <Checkbox
                      checked={!!option.checked}
                      onCheckedChange={() => onChecked(index)}
                    />
                    <Typography> {option.title} </Typography>
                  </Box>
                );
              })
            : null}
        </Box>
        <DialogFooter>
          <Button variant="contained" color="error" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="success" onClick={onSavedClick}>
            Print
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PrintModal;
